const polyfills = () => {
	const fillFetch = async () => {
		if ('fetch' in window) return true;

		return import('isomorphic-fetch');
	};

	const fillCoreJs = async () => {
		if (
			'findIndex' in Array.prototype
			&& 'includes' in Array.prototype
			&& 'closest' in Element.prototype
			&& 'assign' in Object
			&& 'keys' in Object
		) return true;

		return import('core-js');
	};

	return Promise.all([
		fillFetch(),
		fillCoreJs(),
	]);
};

export default polyfills;
